import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export var NEW_RELIC_SCRIPT = 'NEW_RELIC_SCRIPT';
export var NEW_RELIC_SCRIPT_SET = 'NEW_RELIC_SCRIPT_SET';